import Vue from 'vue'
import loadAnalyticalComponents from '../components/Forms/analyticalComponents.js'
import dataTools from '../tools/data'
import fieldsDescription from '../tools/fieldsDescription'
import dataDescription from '../tools/dataDescription'

loadAnalyticalComponents()

export default {
  methods: {
    // -------------- copy -------------------------

    copyLocalFields(item) {
      this.copyParametricsToGUI(item, this.inputs)
      for (let field in this.getPropertiesDescription()) {
        if (this.inputs.hasOwnProperty(field)) {
          let fieldType = this.getPropertiesDescription()[field].type
          if (dataDescription[fieldType] != null) {
            this.inputs[field] = dataTools.convertSi2gui(
              this.getFieldType(field),
              item[field]
            )
            this.checkParametricValue(this.inputs, field)
          } else {
            if (fieldType === 'none') {
              this.inputs[field] = dataTools.convertSi2gui(
                this.getVisibilityParameterUnit(
                  item['visibilityParameterType']
                ),
                item[field]
              )
            } else {
              this.inputs[field] = item[field]
              if (fieldsDescription[fieldType] != null) {
                this.checkParametricReference(this.inputs, field)
              }
            }
          }
        }
      }
      if (this.inputs.scriptConfig != null) {
        for (let field in this.inputs.scriptConfig.scriptInputs) {
          this.checkParametricValue(this.inputs, field)
        }
      }
    },

    copyParametricsToGUI(source, destination) {
      if (source.parametricValues == null) {
        return
      }
      destination.parametricValues = JSON.parse(
        JSON.stringify(source.parametricValues)
      ) // copy values, not ref to not update the table
      for (let paramField in destination.parametricValues) {
        destination.parametricValues[paramField].min = dataTools.convertSi2gui(
          this.getFieldType(paramField),
          destination.parametricValues[paramField].min
        )
        destination.parametricValues[paramField].max = dataTools.convertSi2gui(
          this.getFieldType(paramField),
          destination.parametricValues[paramField].max
        )
        destination.parametricValues[paramField].rangeStep =
          dataTools.convertSi2gui(
            this.getFieldType(paramField),
            destination.parametricValues[paramField].rangeStep
          )
        let valuesArray = destination.parametricValues[paramField].values
        if (Array.isArray(valuesArray) && valuesArray.length) {
          for (let value of valuesArray) {
            destination.parametricValues[paramField].values[
              valuesArray.indexOf(value)
            ] = dataTools.convertSi2gui(this.getFieldType(paramField), value)
          }
        }
      }
      destination.parametricReferences = JSON.parse(
        JSON.stringify(source.parametricReferences)
      ) // copy values, not ref to not update the table
    },

    checkParametricReference(baseObject, field) {
      if (
        baseObject.parametricReferences == null ||
        baseObject.parametricReferences[field] == null
      ) {
        Vue.set(
          baseObject.parametricReferences,
          field,
          this.buildDefaultParametricReference(field)
        ) // use vue.set to have it reactive
      }
    },

    checkParametricValue(baseObject, field) {
      if (baseObject.parametricValues[field] == null) {
        Vue.set(
          baseObject.parametricValues,
          field,
          this.buildDefaultParametricValue(field)
        ) // use vue.set to have it reactive
      }
    },

    // ----------------- clear ----------------------

    clearLocalFields() {
      for (let field in this.getPropertiesDescription()) {
        if (this.inputs.hasOwnProperty(field)) {
          this.inputs[field] = this.getDefaultValue(field)
          let fieldType = this.getPropertiesDescription()[field].type
          if (dataDescription[fieldType] != null) {
            this.checkParametricValue(this.inputs, field)
          } else if (fieldsDescription[fieldType] != null) {
            this.checkParametricReference(this.inputs, field)
          }
        }
      }
    },

    // -------------- build paametrics ------------------------

    buildDefaultParametricReference(field) {
      return {
        active: false,
        references: []
      }
    },

    buildDefaultParametricValue(field) {
      let parentDesc = this.getPropertiesDescription()
      let value = {
        active: false,
        min: 0,
        max: 100,
        rangeStep: 10,
        rangeNumber: 11,
        values: [],
        rangeType: 'Number'
      }
      if (
        parentDesc[field] != null &&
        parentDesc[field].parametricInit != null
      ) {
        value.min = parentDesc[field].parametricInit.min
        value.max = parentDesc[field].parametricInit.max
        value.rangeStep = parentDesc[field].parametricInit.rangeStep
        value.rangeNumber = parentDesc[field].parametricInit.rangeNumber
        value.values = parentDesc[field].parametricInit.values
        value.rangeType = parentDesc[field].parametricInit.rangeType
      }
      this.updateParametricStepAndNumber(field, value)
      return value
    },

    buildDefaultParametricValueForCustomField(fieldName) {
      let value = {
        active: false,
        min: 0,
        max: 100,
        rangeStep: 10,
        rangeNumber: 11,
        values: [],
        rangeType: 'Number'
      }
      this.updateParametricStepAndNumber(fieldName, value)
      return value
    },

    updateParametricStepAndNumberfromParent(field, parent) {
      let paramVal = parent.parametricValues[field]
      this.updateParametricStepAndNumber(field, paramVal)
    },

    updateParametricStepAndNumber(field, paramVal) {
      let rangeNumber = paramVal.rangeNumber
      let rangeStep = paramVal.rangeStep
      let min = paramVal.min
      let max = paramVal.max
      if (paramVal.rangeType === 'Step') {
        if (rangeStep > 0.0) {
          paramVal.rangeNumber = Math.ceil((max - min) / rangeStep) + 1 // + 1 for the las one
        } else {
          paramVal.rangeNumber = 2
        }
      } else if (paramVal.rangeType === 'Number') {
        if (rangeNumber > 1) {
          paramVal.rangeStep = (max - min) / (rangeNumber - 1)
        } else {
          paramVal.rangeStep = max - min
        }
      } else if (paramVal.rangeType === 'Values') {
        // nothing
      }
    },

    // ------------------ add local fields ---------------------

    addFieldsListToBaseObject(
      baseObject,
      fieldsList,
      parentObject = this.inputs
    ) {
      baseObject.parametricValues = {}
      baseObject.parametricReferences = {}
      for (let field of fieldsList) {
        let fieldDesc = this.getPropertiesDescription()[field]
        let fieldType
        if (fieldDesc && fieldDesc.type) {
          fieldType = fieldDesc.type
        } else {
          fieldType = null
        }
        if (
          fieldType === 'enum' ||
          fieldType === 'boolean' ||
          fieldType === 'date'
        ) {
          baseObject[field] = parentObject[field]
        } else if (fieldsDescription[fieldType] != null) {
          this.addParametricReferenceField(baseObject, field, parentObject)
        } else {
          this.addParametricValueField(baseObject, field, parentObject)
        }
      }
      if (
        parentObject &&
        parentObject.scriptConfig &&
        parentObject.scriptConfig.scriptInputs
      ) {
        for (let field in parentObject.scriptConfig.scriptInputs) {
          this.addParametricValueField(baseObject, field, parentObject)
        }
      }
      return baseObject
    },

    addParametricReferenceField(baseObject, field, parentObject) {
      baseObject[field] = parentObject[field]
      if (
        parentObject.parametricReferences != null &&
        parentObject.parametricReferences[field] != null &&
        parentObject.parametricReferences[field].active
      ) {
        baseObject.parametricReferences[field] =
          parentObject.parametricReferences[field]
        baseObject[field] = null
      }
      return baseObject
    },

    addParametricValueField(baseObject, field, parentObject) {
      baseObject[field] = dataTools.convertGui2si(
        this.getFieldType(field),
        parentObject[field]
      )
      if (
        parentObject.parametricValues[field] != null &&
        parentObject.parametricValues[field].active
      ) {
        baseObject.parametricValues[field] = this.copyActiveParametricValues(
          field,
          parentObject
        )
        baseObject[field] = null
      }
      return baseObject
    },

    copyActiveParametricValues(field, parentObject) {
      let guiParametric = parentObject.parametricValues[field]
      let newParametricField = JSON.parse(JSON.stringify(guiParametric)) // copy values, not ref to not update the table
      newParametricField.min = dataTools.convertGui2si(
        this.getFieldType(field),
        guiParametric.min
      )
      newParametricField.max = dataTools.convertGui2si(
        this.getFieldType(field),
        guiParametric.max
      )
      newParametricField.rangeStep = dataTools.convertGui2si(
        this.getFieldType(field),
        guiParametric.rangeStep
      )
      if (newParametricField.rangeType === 'Values') {
        for (let index in newParametricField.values) {
          newParametricField.values[index] = dataTools.convertGui2si(
            this.getFieldType(field),
            guiParametric.values[index]
          )
        }
        newParametricField.values.sort()
      }
      return newParametricField
    },

    // ---------------------- field checks -----------------

    getFieldState(parentObject, fieldName, required) {
      if (fieldName === 'scriptConfig') {
        if (parentObject.scriptConfig) {
          return {
            value: true,
            message: ''
          }
        } else {
          return {
            value: false,
            message:
              'Internal error, scripting is null. Please contact the support team.'
          }
        }
      }
      // For custom fields, only check min < max
      if (
        parentObject &&
        parentObject.scriptConfig &&
        parentObject.scriptConfig.scriptInputs
      ) {
        let found = parentObject.scriptConfig.scriptInputs[fieldName]
        if (found) {
          if (this.getPropertiesDescription()[fieldName] != null) {
            return {
              value: false,
              message:
                'Field ' +
                fieldName +
                ' already exists and can not be used for custom inputs'
            }
          }
          return this.getParametricCustomFieldState(parentObject, fieldName)
        }
      }
      let fieldDesc = this.getPropertiesDescription()[fieldName]
      if (fieldDesc == null) {
        let state = {
          value: false,
          message:
            'Internal error : Undefined getPropertiesDescription for ' +
            fieldName
        }
        //console.log(state.message)
        return state
      }
      let fieldType = fieldDesc.type
      if (fieldType === 'enum') {
        return this.getEnumFieldState(parentObject, fieldName, required)
      } else if (fieldType === 'boolean') {
        return { value: true, message: '' }
      } else if (fieldType === 'date') {
        return this.getDateFieldState(parentObject, fieldName)
      } else if (fieldType === 'datetime') {
        return this.getDateTimeFieldState(parentObject, fieldName)
      } else if (fieldType === 'none') {
        return { value: true, message: '' }
      } else if (fieldsDescription[fieldType] != null) {
        return this.getReferenceFieldState(parentObject, fieldName)
      } else if (fieldType === 'string') {
        return { value: true, message: '' }
      } else if (fieldType === 'list') {
        if (
          parentObject[fieldName] == null ||
          !Array.isArray(parentObject[fieldName])
        ) {
          return { value: false, message: fieldName + ' is not an array' }
        }
        return { value: true, message: '' }
      }
      return this.getParametricFieldState(parentObject, fieldName)
    },

    getOkState() {
      return {
        value: true, // do not initialize with null, it means field empty
        message: true
      }
    },

    getReferenceFieldState(parentObject, fieldName) {
      let state = {
        value: true, // do not initialize with null, it means field empty
        message: true
      }
      if (
        parentObject.parametricReferences != null &&
        parentObject.parametricReferences[fieldName] != null
      ) {
        if (
          parentObject.parametricReferences[fieldName].active &&
          parentObject.parametricReferences[fieldName].references.length === 0
        ) {
          state.value = false
          state.message = 'Please select at least one element'
          return state
        } else if (
          parentObject[fieldName] == null &&
          !parentObject.parametricReferences[fieldName].active
        ) {
          state.value = null
          return state
        }
      }
      return state
    },

    getDateFieldState(parentObject, fieldName) {
      let state = {
        value: true,
        message: ''
      }
      var dateReg = /^\d\d\d\d-(0?[1-9]|1[0-2])-(0?[1-9]|[12][0-9]|3[01])$/
      if (parentObject[fieldName] === '') {
        state.value = null
      } else if (isNaN(Date.parse(parentObject[fieldName]))) {
        state.value = false
        state.message = 'Date format is not valid'
      } else if (parentObject[fieldName].match(dateReg) == null) {
        state.value = false
        state.message = 'Date format is not valid'
      }
      return state
    },

    getDateTimeFieldState(parentObject, fieldName) {
      let state = {
        value: true,
        message: ''
      }
      if (parentObject[fieldName] === '') {
        state.value = null
      } else if (isNaN(Date.parse(parentObject[fieldName]))) {
        state.value = false
        state.message = 'Invalid date'
      }
      return state
    },

    getParametricFieldState(parentObject, fieldName) {
      let state = {
        value: true, // do not initialize with null, it means field empty
        message: true,
        min: {
          value: true, // do not initialize with null, it means field empty
          message: ''
        },
        max: {
          value: true, // do not initialize with null, it means field empty
          message: ''
        },
        rangeField: {
          value: true, // do not initialize with null, it means field empty
          message: ''
        }
      }
      if (
        parentObject.parametricValues[fieldName] != null &&
        parentObject.parametricValues[fieldName].active === true
      ) {
        let fieldDesc = this.getPropertiesDescription()[fieldName]
        let fieldType = fieldDesc.type
        if (parentObject.parametricValues[fieldName].rangeType !== 'Values') {
          let minVal = parentObject.parametricValues[fieldName].min
          if (!dataTools.isNumber(minVal)) {
            let errorState = {
              value: false,
              message: 'min is not a number'
            }
            this.updateState(state.min, errorState)
          } else {
            this.updateState(
              state.min,
              this.getFieldValueState(fieldDesc, fieldType, minVal)
            )
          }
          let maxVal = parentObject.parametricValues[fieldName].max
          if (!dataTools.isNumber(maxVal)) {
            let errorState = {
              value: false,
              message: 'max is not a number'
            }
            this.updateState(state.max, errorState)
          } else {
            this.updateState(
              state.max,
              this.getFieldValueState(fieldDesc, fieldType, maxVal)
            )
          }
          if (parseFloat(minVal) >= parseFloat(maxVal)) {
            let errorState = {
              value: false,
              message:
                'min (' + minVal + ') should be lower than max (' + maxVal + ')'
            }
            this.updateState(state.min, errorState)
            this.updateState(state.max, errorState)
          }

          if (parentObject.parametricValues[fieldName].rangeType === 'Number') {
            const rangeNumber =
              parentObject.parametricValues[fieldName].rangeNumber
            if (rangeNumber > 2000 || rangeNumber < 2) {
              let errorState = {
                value: false,
                message:
                  'Number of points (' +
                  rangeNumber +
                  ') should be greater or equal to 2 and lower or equal to 2000'
              }
              this.updateState(state.rangeField, errorState)
            }
          } else if (
            parentObject.parametricValues[fieldName].rangeType === 'Step'
          ) {
            const rangeStep = parentObject.parametricValues[fieldName].rangeStep

            if (rangeStep < 0.1 || rangeStep > maxVal - minVal) {
              let errorState = {
                value: false,
                message:
                  'Step (' +
                  rangeStep +
                  ') should be greater or equal to 0.1 and lower or equal to max-min'
              }
              this.updateState(state.rangeField, errorState)
            }
          }
        }
        this.getRangeFieldState(parentObject, fieldName, state)
        state.value =
          state.min.value && state.max.value && state.rangeField.value
      } else {
        let fieldDesc = this.getPropertiesDescription()[fieldName]
        this.updateState(
          state,
          this.getFieldValueState(
            fieldDesc,
            fieldDesc.type,
            parentObject[fieldName]
          )
        )
        if (state.value === true) {
          if (fieldName.includes('min')) {
            let currentValue = parentObject[fieldName]
            let respectiveMaxValue =
              parentObject[fieldName.replace('min', 'max')]
            if (
              dataTools.isNumber(respectiveMaxValue) &&
              parseFloat(currentValue) > parseFloat(respectiveMaxValue)
            ) {
              state.value = false
              state.message =
                'min (' +
                currentValue +
                ') should be lower than max (' +
                respectiveMaxValue +
                ')'
              return state
            }
          } else if (fieldName.includes('max')) {
            let currentValue = parentObject[fieldName]
            let respectiveMinValue =
              parentObject[fieldName.replace('max', 'min')]
            if (
              dataTools.isNumber(respectiveMinValue) &&
              parseFloat(currentValue) < parseFloat(respectiveMinValue)
            ) {
              state.value = false
              state.message =
                'min (' +
                respectiveMinValue +
                ') should be lower than max (' +
                currentValue +
                ')'
              return state
            }
          }
        }
      }
      return state
    },

    getParametricCustomFieldState(parentObject, fieldName) {
      let state = {
        value: true, // do not initialize with null, it means field empty
        message: true,
        min: {
          value: true, // do not initialize with null, it means field empty
          message: true
        },
        max: {
          value: true, // do not initialize with null, it means field empty
          message: true
        },
        rangeField: {
          value: true, // do not initialize with null, it means field empty
          message: true
        }
      }
      if (
        parentObject.parametricValues[fieldName] != null &&
        parentObject.parametricValues[fieldName].active
      ) {
        if (parentObject.parametricValues[fieldName].rangeType !== 'Values') {
          let minVal = parentObject.parametricValues[fieldName].min
          if (!dataTools.isNumber(minVal)) {
            let errorState = {
              value: false,
              message: 'min is not a number'
            }
            this.updateState(state.min, errorState)
          }
          let maxVal = parentObject.parametricValues[fieldName].max
          if (!dataTools.isNumber(maxVal)) {
            let errorState = {
              value: false,
              message: 'max is not a number'
            }
            this.updateState(state.max, errorState)
          }
          if (parseFloat(minVal) >= parseFloat(maxVal)) {
            let errorState = {
              value: false,
              message:
                'min (' + minVal + ') should be lower than max (' + maxVal + ')'
            }
            this.updateState(state.min, errorState)
            this.updateState(state.max, errorState)
          }
        }
        this.getRangeFieldState(parentObject, fieldName, state)
        state.value =
          state.min.value && state.max.value && state.rangeField.value
        //console.log(state.min.value, state.max.value, state.rangeField.value)
        //console.log('message: ' + state.message)
      } else {
        //console.log('update state')
        this.updateState(state, this.getOkState())
      }
      //console.log(fieldName)
      return state
    },

    getRangeFieldState(parentObject, fieldName, state) {
      if (parentObject.parametricValues[fieldName].rangeType === 'Values') {
        let valuesArray = parentObject.parametricValues[fieldName].values
        if (!Array.isArray(valuesArray) || valuesArray.length <= 0) {
          state.rangeField.value = false
          state.rangeField.message = 'Field is required'
          return
        } else {
          for (let index = 0; index < valuesArray.length; index++) {
            const element = valuesArray[index]
            if (valuesArray.includes(element, index + 1)) {
              state.rangeField.value = false
              state.rangeField.message = 'Duplicate values are not allowed'
              return
            }
          }
          state.rangeField.value = true
          state.rangeField.message = true
          return
        }
      } else {
        this.updateState(
          state.rangeField,
          this.getFieldValueState(
            dataDescription.rangeNumber,
            'rangeNumber',
            parentObject.parametricValues[fieldName].rangeNumber
          )
        )
        this.updateState(
          state.rangeField,
          this.getFieldValueState(
            dataDescription.rangeStep,
            'rangeStep',
            parentObject.parametricValues[fieldName].rangeStep
          )
        )
      }
      if (state.rangeField.value === null) {
        state.rangeField.value = false
        state.rangeField.message = 'Field is required'
      }
    },

    // ---------------------- display parametric in table -----------------

    displayRangeValue(exoData, field) {
      let toDisplay = ''
      if (exoData != null) {
        toDisplay = dataTools.convertSi2Display(
          this.getFieldType(field),
          exoData[field]
        )
        let paramVal = exoData.parametricValues
          ? exoData.parametricValues[field]
          : exoData[field]
        if (paramVal != null && paramVal.active) {
          toDisplay = '['
          if (paramVal.rangeType === 'Values') {
            toDisplay += dataTools.convertSi2Display(
              this.getFieldType(field),
              paramVal.values[0]
            )
            paramVal.values.length === 2
              ? (toDisplay += ', ')
              : (toDisplay += ' ... ')
            toDisplay +=
              dataTools.convertSi2Display(
                this.getFieldType(field),
                paramVal.values[paramVal.values.length - 1]
              ) +
              '] (' +
              paramVal.values.length +
              ')'
          } else {
            toDisplay += dataTools.convertSi2Display(
              this.getFieldType(field),
              paramVal.min
            )
            paramVal.rangeNumber === 2
              ? (toDisplay += ', ')
              : (toDisplay += ' ... ')
            toDisplay +=
              dataTools.convertSi2Display(
                this.getFieldType(field),
                paramVal.max
              ) +
              '] (' +
              paramVal.rangeNumber +
              ')'
          }
        }
      }
      return toDisplay
    },

    displayEnumValue(exoData, field) {
      try {
        let desc = fieldsDescription[exoData.typeName]['properties'][field]
        if (exoData[field] && Array.isArray(exoData[field])) {
          return (
            '[' +
            exoData[field]
              .map((el) => desc['values'].find((val) => val.value === el).text)
              .join(', ') +
            ']'
          )
        } else if (exoData[field]) {
          return desc['values'].find((el) => el.value === exoData[field]).text
        }
      } catch (e) {
        return 'undefined'
      }
    },

    displayRefValue(exoData, field) {
      let toDisplay = ''
      let paramVal
      if (exoData.parametricReferences != null) {
        paramVal = exoData.parametricReferences[field]
      } else {
        paramVal = null
      }

      if (paramVal != null && paramVal.active) {
        toDisplay = paramVal.references.map((id) =>
          this.getDisplayedNameFromId(id, field)
        )
      } else if (
        exoData[field] != null &&
        exoData[field].displayedName != null
      ) {
        toDisplay = exoData[field].displayedName
      }
      return toDisplay
    },

    getDisplayedNameFromId(id, field) {
      let obj = this.getRefList(field).find((obj) => obj.value.id === id)
      return obj != null ? obj.value.displayedName : 'error'
    }
  }
}
